import script from "./AnimationController.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimationController.vue?vue&type=script&setup=true&lang=js"

import "./AnimationController.vue?vue&type=style&index=0&id=66b8f807&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66b8f807"]])

export default __exports__